import { userOptionsStore } from '~/shared/api'
import { TransactionBalanceTypeEnum } from '~/shared/config/enums'
import { canShowObject } from '~/shared/lib/utils'
import { Tab, Tabs } from '~/shared/ui/RoutesTabs/type'
import { BalanceByTypePage } from './BalanceByTypePage'

export const useConfigTabs = (): Tabs => {
  return [
    {
      labelI18n: 'current balance',
      path: '/current',
      content: (
        <BalanceByTypePage balanceType={TransactionBalanceTypeEnum.MAIN} />
      ),
    },
    {
      labelI18n: 'credit balance',
      path: '/by-dept',
      content: (
        <BalanceByTypePage
          balanceType={TransactionBalanceTypeEnum.BY_DEPT}
          canComing={false}
          canSpending={false}
        />
      ),
    },
    {
      labelI18n: 'bonus balance',
      path: '/by-bonus',
      content: (
        <BalanceByTypePage
          balanceType={TransactionBalanceTypeEnum.BY_BONUS}
          canComing={false}
          canSpending={false}
        />
      ),
    },
    ...canShowObject<Tab>(userOptionsStore.depositBalanceEnabled, {
      labelI18n: 'deposit balance',
      path: '/by-deposit',
      content: (
        <BalanceByTypePage
          balanceType={TransactionBalanceTypeEnum.BY_DEPOSIT}
          canComing={false}
          canSpending={false}
        />
      ),
    }),
  ]
}
